module.exports = __webpack_public_path__ + "static/media/chevron-thin-right.19066893.svg";